<div class="modal fade" id="modalRelJasper" tabindex="-1" role="dialog" aria-labelledby="TituloModalCentralizado"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog  modal-lg" role="document">
    <div class="modal-content" style=" border-radius: 10px; height: fit-content;">
      <div class="modal-header justify-content-between">
        <h5 class="modal-title">Relatório {{title}}</h5>
        <img class="bt-fechar" src="assets/img/icon_bt-limpar_header.svg" (click)="fechaModal()" style="cursor: pointer;">
      </div>
      <div class="modal-body">
        <app-formulario-relatorio [formFields]="formFields | async "></app-formulario-relatorio>
        <button hidden id="defineTipoRel" (click)="defineInputsRelatorios()"></button>
      </div>
    </div>
  </div>
</div>
